import { StorageRepository } from './StorageRepository';

export class StorageRepositoryLocal implements StorageRepository {
  async getItem({ key }: { key: string }): Promise<string | null> {
    return localStorage.getItem(key);
  }
  async setItem({ key, item }: { key: string; item: string }): Promise<void> {
    return new Promise((resolve) => {
      localStorage.setItem(key, item);
      resolve();
    });
  }
  async removeItem({ key }: { key: string }): Promise<void> {
    return new Promise((resolve) => {
      localStorage.removeItem(key);
      resolve();
    });
  }
}
